import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/Header/Header';
import Footer from '../home/Footer/Footer';
import PublicPlansService from '../../services/PublicPlansService';

const formatPrice = (plan) => {
  const price = Number(plan.monthly_price ?? 0);
  if (price === 0) return 'Gratis';
  const currency = plan.currency || 'USD';
  return `$${price.toLocaleString('en-US')} ${currency}/mes`;
};

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    PublicPlansService.listPlans()
      .then((data) => {
        if (mounted) setPlans(data);
      })
      .catch((err) => {
        if (mounted) setError(err?.message || 'No se pudo cargar el catálogo de planes.');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <Header />
      <main className="flex-grow">
        <section className="py-16 px-4">
          <div className="max-w-5xl mx-auto text-center mb-12">
            <h1 className="text-4xl font-extrabold text-white mb-4">Precios</h1>
            <p className="text-lg text-gray-300">
              Elige el plan que mejor se ajuste a tu equipo. Podés empezar gratis y
              subir de plan cuando lo necesites, sin perder tu historial.
            </p>
          </div>

          {loading && (
            <p className="text-center text-gray-400">Cargando planes...</p>
          )}

          {error && !loading && (
            <p className="text-center text-red-400">{error}</p>
          )}

          {!loading && !error && (
            <div className="max-w-5xl mx-auto grid gap-8 md:grid-cols-3">
              {plans.map((plan) => (
                <div
                  key={plan.plan_id}
                  className="bg-gray-900 border-2 border-orange-500/40 rounded-2xl p-8 flex flex-col"
                >
                  <h2 className="text-2xl font-bold text-orange-500 mb-2">{plan.name}</h2>
                  <p className="text-3xl font-extrabold text-white mb-4">{formatPrice(plan)}</p>
                  <p className="text-gray-300 mb-6">
                    {Number(plan.included_credits ?? 0).toLocaleString('en-US')} créditos incluidos por mes
                    {plan.allow_overage ? ' · consumo adicional disponible' : ''}
                  </p>
                  <Link
                    to="/register"
                    className="mt-auto inline-block text-center bg-black text-white border-2 border-orange-500 px-6 py-3 rounded-full shadow-lg hover:bg-orange-500/10 transition"
                  >
                    Comenzar
                  </Link>
                </div>
              ))}

              {plans.length === 0 && (
                <p className="col-span-3 text-center text-gray-400">
                  Todavía no hay planes publicados.
                </p>
              )}
            </div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
